import {
  AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

export default function ConfirmButton({ label, title, description, confirmLabel = "Confirmer", onConfirm, testId, className = "mpl-btn-ghost", children }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button type="button" className={className} data-testid={testId}>{label}</button>
      </AlertDialogTrigger>
      <AlertDialogContent className="border-white/10 bg-[#131B30] text-white">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        {children}
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-full border-white/10 bg-transparent text-white hover:bg-white/5" data-testid={`${testId}-cancel`}>Annuler</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="rounded-full bg-[#B7F52A] font-bold text-[#05070D] hover:bg-[#A3E01F]" data-testid={`${testId}-confirm`}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
